import React, { useState } from "react";

function FAQItem({ question, answer, index }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`faq-item ${isOpen ? "open" : ""}`}>
      <button className="faq-question" onClick={() => setIsOpen(!isOpen)}>
        <span className="faq-number">{String(index + 1).padStart(2, "0")}</span>
        <span className="faq-text">{question}</span>
        <span className={`faq-icon ${isOpen ? "rotated" : ""}`}>+</span>
      </button>

      <div className={`faq-answer ${isOpen ? "show" : ""}`}>
        <p>{answer}</p>
      </div>
    </div>
  );
}

export default FAQItem;
